import { APP_NAME } from './brand';

/**
 * Plain-text reason an address cannot sign in. The sign-in card shows the same
 * words, with the address emphasised, and adds a link when `signupPath` is set.
 */
export function ineligibleSignInMessage(email: string): string {
  return `${email} isn't invited to ${APP_NAME} yet. Ask whoever invited you to check the address, or use an email you've added to your account.`;
}

/** Details on a `not_allowed` sign-in error. `signupPath` is null while Grams is invite-only. */
export interface IneligibleSignInDetails {
  email: string;
  signupPath: string | null;
}

/** A same-app path (`/pricing`), never an external or protocol-relative URL. */
function isSignupPath(value: unknown): value is string | null {
  if (value === null) return true;
  return typeof value === 'string' && value.startsWith('/') && !value.startsWith('//') && !value.includes('\\') && !value.includes('://');
}

/** The ineligible-sign-in details, or null when this error is some other refusal. */
export function ineligibleSignInDetails(value: unknown): IneligibleSignInDetails | null {
  if (!value || typeof value !== 'object') return null;
  const email = (value as { email?: unknown }).email;
  const signupPath = (value as { signupPath?: unknown }).signupPath;
  if (typeof email !== 'string' || email.length === 0 || email.length > 254) return null;
  if (!isSignupPath(signupPath)) return null;
  return { email, signupPath };
}
